import React from 'react'

export interface TabItem { key: string; label: React.ReactNode; badge?: string | number; disabled?: boolean; disabledTooltip?: string }

interface TabsProps { tabs: TabItem[]; active: string; onChange: (key: string) => void; rightSlot?: React.ReactNode; style?: React.CSSProperties }

export const Tabs: React.FC<TabsProps> = ({ tabs, active, onChange, rightSlot, style }) => (
  <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid var(--border)', marginBottom: '1.25rem', gap: '0.1rem', overflowX: 'auto', WebkitOverflowScrolling: 'touch' as any, scrollbarWidth: 'none' as any, ...style }}>
    {tabs.map((tab) => (
      <button
        key={tab.key}
        onClick={() => !tab.disabled && onChange(tab.key)}
        title={tab.disabled ? tab.disabledTooltip : undefined}
        disabled={tab.disabled}
        style={{ padding: '0.65rem 1.1rem', background: 'transparent', border: 'none', borderBottom: active === tab.key ? '2px solid var(--accent-primary)' : '2px solid transparent', color: tab.disabled ? 'var(--text-disabled, var(--text-muted))' : active === tab.key ? 'var(--accent-primary)' : 'var(--text-muted)', cursor: tab.disabled ? 'not-allowed' : 'pointer', fontWeight: active === tab.key ? 600 : 400, fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '-1px', whiteSpace: 'nowrap', transition: 'color 0.15s', opacity: tab.disabled ? 0.45 : 1 }}
      >
        {tab.label}
        {tab.disabled && <span style={{ fontSize: '0.7rem', lineHeight: 1 }}>🔒</span>}
        {tab.badge !== undefined && !tab.disabled && (<span style={{ background: active === tab.key ? 'rgba(124,58,237,0.15)' : 'var(--bg-elevated)', color: active === tab.key ? 'var(--accent-primary)' : 'var(--text-muted)', borderRadius: '20px', padding: '0.05rem 0.45rem', fontSize: '0.7rem', fontWeight: 600 }}>{tab.badge}</span>)}
      </button>
    ))}
    {rightSlot && (<><div style={{ flex: 1 }} />{rightSlot}</>)}
  </div>
)
